<template>
  <div class="red card">
    <div class="content">
      <div class="center aligned header">
        Derniers signalements
      </div>
      <div class="center aligned description">
        <div
          :class="{ active: loading }"
          class="ui inverted dimmer"
        >
          <div class="ui text loader">
            Récupération des signalements en cours...
          </div>
        </div>
        <div class="ui relaxed list">
          <div
            v-for="(item, index) in features.slice(0,5)"
            :key="item.properties.title + index"
            class="item"
          >
            <div class="content">
              <div>
                <FeatureFetchOffsetRoute
                  :feature-id="item.id"
                  :properties="item.properties"
                />
              </div>
              <div class="description">
                <em>[ {{ item.properties.created_on | formatDate 
                }}<span
                  v-if="user && item.properties.display_creator"
                >, par {{ item.properties.display_creator }}
                </span>]</em>
              </div>
            </div>
          </div>
          <em
            v-if="features.length === 0 && !loading"
          >Aucun signalement pour le moment.</em>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex';
import FeatureFetchOffsetRoute from '@/components/Feature/FeatureFetchOffsetRoute';

import { formatStringDate } from '@/utils';

export default {

  name: 'ProjectLastFeatures',

  filters: {
    formatDate(value) {
      return formatStringDate(value);
    },
  },

  components: {
    FeatureFetchOffsetRoute,
  },

  data() {
    return {
      loading: true,
    };
  },

  computed: {
    ...mapState('feature', [
      'features'
    ]),
    ...mapState([
      'user'
    ]),
  },

  mounted() {
    this.fetchLastFeatures();
  },

  methods: {
    fetchLastFeatures() {
      this.loading = true;
      this.$store.dispatch('feature/GET_PROJECT_FEATURES', {
        project_slug: this.$route.params.slug,
        ordering: '-created_on',
        limit: 5,
      })
        .then(() => {
          this.loading = false;
        })
        .catch((err) => {
          console.error(err);
          this.loading = false;
        });
    }
  }
};
</script>
